import {Button, Image, Link, Navbar, NavbarBrand, NavbarContent, NavbarItem} from "@nextui-org/react";
import React, {useState} from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faBars} from "@fortawesome/free-solid-svg-icons";


const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen((prev) => !prev);
    };
    return (
        <Navbar
            isBordered={false}
            isBlurred={false}
            maxWidth="full"
            className="bg-transparent "
        >
            {/* Brand */}
            <NavbarBrand className="flex items-center justify-center sm:justify-start w-full">
                <div className="flex items-center justify-center">
                    <Image
                        removeWrapper
                        alt="ubion logo"
                        className="object-contain h-auto max-h-20 sm:max-h-1 md:max-h-16 lg:max-h-20 p-4 sm:p-10 md:p-3 lg:p-3"
                        src="/images/UBIONLOGO.png"
                        width={300} // Adjust to fit your layout
                        height={100} // Adjust to fit your layout
                    />
                </div>
            </NavbarBrand>

            {/* Desktop NavLinks: visible on small screens and up */}
            <NavbarContent
                className="hidden sm:flex gap-4 font-bold"
                justify="center"
            >
                <NavbarItem>
                    <Link color="foreground" href="/">
                        Unternehmen
                    </Link>
                </NavbarItem>
                <NavbarItem>
                    <Link color="foreground" href="/">
                        Künstliche Intelligenz
                    </Link>
                </NavbarItem>
                {/*<NavbarItem>*/}
                {/*    <Link color="foreground" href="#">*/}
                {/*        Integration*/}
                {/*    </Link>*/}
                {/*</NavbarItem>*/}
            </NavbarContent>

            {/* Desktop Right-Side Content */}
            <NavbarContent justify="end" className="hidden sm:flex">
                {/*<NavbarItem>*/}
                {/*    <Button*/}
                {/*        as={Link}*/}
                {/*        className="bg-ubiTextForLight"*/}
                {/*        href="#"*/}
                {/*        variant="flat"*/}
                {/*    >*/}
                {/*        Nachricht senden*/}
                {/*    </Button>*/}
                {/*</NavbarItem>*/}
            </NavbarContent>

            {/* Mobile Menu Toggle Button: visible on small screens only */}
            <div className="flex sm:hidden">
                <Button
                    isIconOnly
                    variant="light"
                    onPress={toggleMenu}
                    className="text-white hover:bg-white/10"
                >
                    <FontAwesomeIcon icon={faBars} size="lg"/> {/* Font Awesome Icon */}
                </Button>
            </div>

            {/* Mobile Menu: show if isMenuOpen is true */}
            {isMenuOpen && (
                <div
                    className="absolute top-full right-0 w-48 bg-black/80 border text-white rounded shadow-2xl backdrop-blur-lg z-50">
                    <NavbarItem className="text-sm px-4 py-2 hover:bg-white/10">
                        <Link href="/" color="foreground" className="block">
                            Unternehmen
                        </Link>
                    </NavbarItem>
                    <NavbarItem className="text-sm px-4 py-2 hover:bg-white/10">
                        <Link href="/" color="foreground" className="block">
                            Künstliche Intelligenz
                        </Link>
                    </NavbarItem>
                    <NavbarContent justify="end" className="hidden sm:flex">
                        <p></p>
                        {/*<NavbarItem>*/}
                        {/*    <Button*/}
                        {/*        as={Link}*/}
                        {/*        className="bg-ubiTextForLight"*/}
                        {/*        href="#"*/}
                        {/*        variant="flat"*/}
                        {/*    >*/}
                        {/*        Nachricht senden*/}
                        {/*    </Button>*/}{/*<NavbarItem>*/}
                        {/*    <Button*/}
                        {/*        as={Link}*/}
                        {/*        className="bg-ubiTextForLight"*/}
                        {/*        href="#"*/}
                        {/*        variant="flat"*/}
                        {/*    >*/}
                        {/*        Nachricht senden*/}
                        {/*    </Button>*/}
                        {/*</NavbarItem>*/}
                    </NavbarContent>
                </div>
            )}
        </Navbar>
    )

}

export default Header;
